export const SELF_RATING_MAX = 5;

export const STATUS = {
  UNINITIALIZED: 'edrolo/lessons/UNINITIALIZED',
  LOADING: 'edrolo/lessons/LOADING',
  SUBMITTING: 'edrolo/lessons/SUBMITTING',
  READY: 'edrolo/lessons/READY',
  COMPLETE: 'edrolo/lessons/COMPLETE',
  FAILURE: 'edrolo/lessons/FAILURE',
  NOT_FOUND: 'edrolo/lessons/NOT_FOUND',
};
